import Vue from 'vue';
import App from './index.vue';
import { utils } from '_lib/utils';
import '_lib/sm.js';

const KEY =
  '-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDZgjVwAiKTjZ55nG+mW6r3TSU4\nECvNYqDMIS/bhCj2QaH5GI/KZb2TBp+CBvUj9SLFnmJQ0kzHzHoGZCQ88VevCffF7JePGF9cmKQqotlfTKbV4oxV5iLz7JSG6b/Vg7AXtrTolNtWsa8HiB0tI0YClYaQlOXm4UxLeSxQwSFETwIDAQAB\n-----END PUBLIC KEY-----\n';

if (IS_TEST) {
  Vue.config.productionTip = true;
  Vue.config.devtools = true;
  Vue.config.debug = true;
} else {
  Vue.config.productionTip = false;
}

Vue.prototype.$utils = utils;

import JSEncrypt from 'jsencrypt';
Vue.prototype.encrypt = function (str) {
  // RSA加密
  const encrypt = new JSEncrypt();
  const pubKey = KEY;
  encrypt.setPublicKey(pubKey);
  return encrypt.encrypt(str);
};

// 共有函数
Vue.prototype.$com = {};

import { Loading } from 'element-ui';
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Loading);
Vue.prototype.$message = Message;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
